import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';

import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';
import {
  blueBlack640,
  green400,
  greyLight400,
  yellowOrange300,
} from '../../../theme/videa-style-tokens';
import {
  ASC,
  DESC,
  HOME_LOCATIONS_PAGE_SIZE,
  LIST,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'NAME' is defined but never used.
  NAME,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'REVENUE' is defined but never used.
  REVENUE,
} from '../constants';
import { LocationsTable } from '../locations/table/index.component';

interface Props {
  user: {
    primaryOrganizationId: string;
  };
  sortBy: string;
}

const TopBottomLocationsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5em;
  justify-content: stretch;
  margin: 1em 0;
  padding: 0 1em;
  max-height: 26em;
  min-height: 26em;
  overflow: hidden;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${greyLight400};

  &.top-bottom-practices {
    .practices-list:first-of-type {
      padding-right: 0;
    }

    .practices-list:last-of-type {
      padding-right: 0;
    }
  }

  .practices-list {
    display: flex;
    flex-direction: column;
    min-width: 40em;
    width: 100%;
  }

  .practice-table {
    display: flex;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    box-sizing: border-box;
    border-collapse: separate;
    box-sizing: border-box;

    & .MuiTableRow-root {
      background-color: white;
      &:hover {
        background-color: ${greyLight400};
      }
    }
  }
  .header {
    padding: 1.25em 1em 0;
    display: flex;
    align-items: center;

    .circleGreen {
      height: 1em;
      width: 1em;
      background: ${green400};
      border-radius: 50%;
    }
    .circleYellow {
      height: 1em;
      width: 1em;
      background: ${yellowOrange300};
      border-radius: 50%;
    }
  }
  .headerText {
    font-weight: 600;
    margin-left: 0.75em;
    font-size: 1.25em;
    color: ${blueBlack640};
  }
`;

export const TopBottomLocations = ({ user, sortBy }: Props) => {
  const hiddenColumns = {
    aiFindings: false,
    uniquePatientsWithRestoFindings: false,
    treatmentsPresented: false,
    treatmentsCompleted: false,
    caseCompletionDollars: false,
  };
  return (
    <TopBottomLocationsContainer className="top-bottom-practices">
      <div className="practices-list">
        <div className="header">
          <div className="circleGreen" />
          <VideaTypography variant="headingSmall" className="headerText">
            <Trans>Top Practices</Trans>
          </VideaTypography>
        </div>
        <LocationsTable
          user={user}
          sortBy={sortBy}
          order={DESC}
          hideColumns={hiddenColumns}
          hideFooter={true}
          context={LIST}
          pageSize={HOME_LOCATIONS_PAGE_SIZE}
        />
      </div>
      <div className="practices-list">
        <div className="header">
          <div className="circleYellow" />
          <VideaTypography variant="headingSmall" className="headerText">
            <Trans>Bottom Practices</Trans>
          </VideaTypography>
        </div>
        <LocationsTable
          user={user}
          sortBy={sortBy}
          order={ASC}
          hideColumns={hiddenColumns}
          hideFooter={true}
          context={LIST}
          pageSize={HOME_LOCATIONS_PAGE_SIZE}
        />
      </div>
    </TopBottomLocationsContainer>
  );
};
